export default __webpack_public_path__ + "static/media/bg-risco-equipamento-produto.60754686.webp";